/* Storefront theme: product landing page (gallery, variants, social proof, sticky bar, floating video) */
(function () {
  'use strict';
  var d = document;
  var rand = function (min, max) { return Math.floor(Math.random() * (max - min + 1)) + min; };
  var ss = {
    get: function (k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } },
    set: function (k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} }
  };

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = format || '{{amount}}';
    var m = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var key = m ? m[1] : 'amount';
    function fmt(n, decimals, thou, dec) {
      n = (n / 100).toFixed(decimals);
      var parts = n.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
      return parts.join(dec);
    }
    var v;
    switch (key) {
      case 'amount_no_decimals': v = fmt(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': v = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = fmt(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': v = fmt(cents, 2, "'", '.'); break;
      default: v = fmt(cents, 2, ',', '.');
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, v);
  }

  function initSection(sec) {
    if (!sec || sec._pp) return;
    sec._pp = true;
    var dataEl = sec.querySelector('[data-product-json]');
    var data = {};
    try { data = JSON.parse(dataEl.textContent); } catch (e) { data = { variants: [] }; }

    /* ---------- Gallery ---------- */
    var track = sec.querySelector('[data-gal-track]');
    var thumbs = Array.prototype.slice.call(sec.querySelectorAll('[data-thumb]'));
    var cur = sec.querySelector('[data-gal-current]');
    var slides = track ? track.children : [];
    function goTo(i) {
      if (!slides.length) return;
      i = (i + slides.length) % slides.length;
      track.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' });
    }
    function activeIndex() { return track ? Math.round(track.scrollLeft / (track.clientWidth || 1)) : 0; }
    if (track && slides.length > 1) {
      var st;
      track.addEventListener('scroll', function () {
        clearTimeout(st);
        st = setTimeout(function () {
          var i = activeIndex();
          if (cur) cur.textContent = i + 1;
          thumbs.forEach(function (t, n) {
            t.classList.toggle('is-active', n === i);
            if (n === i && t.parentNode.scrollTo) t.parentNode.scrollTo({ left: t.offsetLeft - 40, behavior: 'smooth' });
          });
          Array.prototype.forEach.call(track.querySelectorAll('video'), function (v) { v.pause(); });
        }, 80);
      }, { passive: true });
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () { goTo(parseInt(t.getAttribute('data-thumb'), 10)); });
      });
      var prev = sec.querySelector('[data-gal-prev]');
      var next = sec.querySelector('[data-gal-next]');
      if (prev) prev.addEventListener('click', function () { goTo(activeIndex() - 1); });
      if (next) next.addEventListener('click', function () { goTo(activeIndex() + 1); });
    }

    /* ---------- Quantity: visible input -> hidden form input ---------- */
    var qtyHidden = sec.querySelector('[data-qty-hidden]');
    var qtyInput = sec.querySelector('[data-qty-input]');
    if (qtyInput && qtyHidden) {
      qtyInput.addEventListener('change', function () {
        var q = Math.max(1, parseInt(qtyInput.value, 10) || 1);
        qtyInput.value = q;
        qtyHidden.value = q;
        qtyHidden.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }

    /* ---------- Variant picker ---------- */
    var picker = sec.querySelector('[data-variant-picker]');
    var idInput = sec.querySelector('[data-variant-input]');
    function selectedOptions() {
      return Array.prototype.map.call(picker.querySelectorAll('fieldset'), function (fs) {
        var c = fs.querySelector('input:checked');
        return c ? c.value : null;
      });
    }
    function updatePrices(v) {
      Array.prototype.forEach.call(sec.querySelectorAll('[data-price]'), function (el) { el.textContent = formatMoney(v.price, data.moneyFormat); });
      var onSale = v.compare > v.price;
      Array.prototype.forEach.call(sec.querySelectorAll('[data-compare]'), function (el) {
        el.textContent = onSale ? formatMoney(v.compare, data.moneyFormat) : '';
        el.hidden = !onSale;
      });
      Array.prototype.forEach.call(sec.querySelectorAll('[data-save]'), function (el) {
        el.hidden = !onSale;
        var p = el.querySelector('[data-save-pct]');
        if (p && onSale) p.textContent = Math.round((v.compare - v.price) * 100 / v.compare);
      });
      var btn = sec.querySelector('[data-buy-btn]');
      var lbl = sec.querySelector('[data-buy-label]');
      if (btn) btn.disabled = !v.available;
      if (lbl) lbl.textContent = v.available ? lbl.getAttribute('data-available') : lbl.getAttribute('data-soldout');
    }
    if (picker && idInput) {
      picker.addEventListener('change', function (e) {
        var fs = e.target.closest('fieldset');
        if (fs) {
          var lab = fs.querySelector('[data-option-label]');
          if (lab) lab.textContent = e.target.value;
        }
        var opts = selectedOptions();
        var v = (data.variants || []).filter(function (x) {
          return x.options.every(function (o, i) { return o === opts[i]; });
        })[0];
        if (!v) return;
        idInput.value = v.id;
        idInput.dispatchEvent(new Event('change', { bubbles: true }));
        updatePrices(v);
        try {
          var url = new URL(location.href);
          url.searchParams.set('variant', v.id);
          history.replaceState({}, '', url.toString());
        } catch (err) {}
        if (!data.secure && v.media && track) {
          var s = track.querySelector('[data-media-id="' + v.media + '"]');
          if (s) goTo(parseInt(s.getAttribute('data-slide'), 10));
        }
        d.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: v } }));
      });
    }

    /* ---------- Live viewers ---------- */
    // Changes about every [data-every] seconds (a little random each time), always to a different number
    Array.prototype.forEach.call(sec.querySelectorAll('[data-viewers]'), function (el) {
      var min = parseInt(el.getAttribute('data-min'), 10) || 10;
      var max = Math.max(min + 1, parseInt(el.getAttribute('data-max'), 10) || 40);
      var every = (parseFloat(el.getAttribute('data-every')) || 2) * 1000;
      var n = rand(min, max);
      el.textContent = n;
      var tick = function () {
        setTimeout(function () {
          var step = rand(1, 3) * (Math.random() < 0.5 ? -1 : 1);
          if (n + step > max || n + step < min) step = -step;
          n = Math.min(max, Math.max(min, n + step));
          el.textContent = n;
          el.classList.remove('is-bump');
          void el.offsetWidth;
          el.classList.add('is-bump');
          tick();
        }, every * (0.7 + Math.random() * 0.6));
      };
      tick();
    });

    /* ---------- Sold counter formatting ---------- */
    Array.prototype.forEach.call(sec.querySelectorAll('[data-num]'), function (el) {
      var n = parseInt(String(el.textContent).replace(/[^\d]/g, ''), 10);
      if (!isNaN(n)) el.textContent = n.toLocaleString('en-US');
    });

    /* ---------- Countdown (restarts per visit session) ---------- */
    Array.prototype.forEach.call(sec.querySelectorAll('[data-countdown]'), function (el, i) {
      var mins = parseInt(el.getAttribute('data-countdown'), 10) || 15;
      var key = 'sf_cd_' + location.pathname + i;
      var end = parseInt(ss.get(key), 10);
      if (!end || end < Date.now()) { end = Date.now() + mins * 60000; ss.set(key, end); }
      function tick() {
        var left = end - Date.now();
        if (left <= 0) { end = Date.now() + mins * 60000; ss.set(key, end); left = mins * 60000; }
        var m = Math.floor(left / 60000), s = Math.floor((left % 60000) / 1000);
        el.textContent = (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s;
      }
      tick();
      setInterval(tick, 1000);
    });

    /* ---------- Sticky order bar ---------- */
    var bar = sec.querySelector('[data-sticky-bar]');
    var cta = sec.querySelector('[data-cta]') || sec.querySelector('.pp-price');
    if (bar && cta && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        var en = entries[0];
        var past = en.boundingClientRect.top < 0;
        bar.classList.toggle('is-show', !en.isIntersecting && past);
      });
      io.observe(cta);
      bar.querySelector('[data-sticky-go]').addEventListener('click', function () {
        cta.scrollIntoView({ behavior: 'smooth', block: 'center' });
        if (bar.getAttribute('data-click') === 'true') {
          var b = cta.querySelector('button, a.btn, [role="button"]');
          if (b) setTimeout(function () { b.click(); }, 450);
        }
      });
    }

    /* ---------- Recent order toast ---------- */
    var toast = sec.querySelector('[data-toast]');
    if (toast && ss.get('sf_toast_off') !== '1') {
      var split = function (s) { return String(s || '').split(',').map(function (x) { return x.trim(); }).filter(Boolean); };
      var names = split(toast.getAttribute('data-names'));
      var cities = split(toast.getAttribute('data-cities'));
      var first = (parseInt(toast.getAttribute('data-first'), 10) || 6) * 1000;
      var every = (parseInt(toast.getAttribute('data-interval'), 10) || 20) * 1000;
      var nameEl = toast.querySelector('[data-toast-name]');
      var cityEl = toast.querySelector('[data-toast-city]');
      var timeEl = toast.querySelector('[data-toast-time]');
      var timer;
      var show = function () {
        if (!names.length || !cities.length) return;
        nameEl.textContent = names[rand(0, names.length - 1)];
        cityEl.textContent = cities[rand(0, cities.length - 1)];
        var mins = rand(1, 14);
        timeEl.textContent = mins + (mins === 1 ? ' minute ago' : ' minutes ago');
        // Top-left: sit just under the header, so the popup never covers the menu button or logo
        if (!toast.classList.contains('toast--bottom')) {
          var hdr = d.querySelector('.section-header');
          var hb = hdr ? hdr.getBoundingClientRect().bottom : 0;
          toast.style.top = Math.max(10, Math.round(hb) + 10) + 'px';
        }
        toast.classList.add('is-show');
        setTimeout(function () { toast.classList.remove('is-show'); }, 5000);
      };
      setTimeout(function () { show(); timer = setInterval(show, every); }, first);
      toast.querySelector('[data-toast-close]').addEventListener('click', function () {
        toast.classList.remove('is-show');
        clearInterval(timer);
        ss.set('sf_toast_off', '1');
      });
    }

    /* ---------- Floating video ---------- */
    var fvid = sec.querySelector('[data-fvid]');
    if (fvid) {
      if (ss.get('sf_fvid_off') === '1') {
        fvid.hidden = true;
      } else {
        var startVid = function () {
          var v = fvid.querySelector('video');
          if (!v) return;
          v.muted = true;
          v.preload = 'auto';
          var p = v.play();
          if (p && p.catch) p.catch(function () {});
        };
        if (d.readyState === 'complete') setTimeout(startVid, 600);
        else window.addEventListener('load', function () { setTimeout(startVid, 600); });
        fvid.querySelector('[data-fvid-close]').addEventListener('click', function (e) {
          e.stopPropagation();
          var v = fvid.querySelector('video');
          if (v) v.pause();
          fvid.hidden = true;
          ss.set('sf_fvid_off', '1');
        });
      }
    }
  }

  function initAll(root) {
    Array.prototype.forEach.call((root || d).querySelectorAll('[data-product-section]'), initSection);
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  d.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
